import { TutorialsComponent } from './core-modules/tutorials/tutorial.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ImageCropperModule } from 'ng2-img-cropper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
// import { DynamicComponentModule } from 'angular2-dynamic-component/index';
// import { NgComponentOutlet } from '@angular/common';
import { appRouting, appRoutingProviders } from './app.routes';
import { BsModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { AppLoginModule } from './core-modules/app-login/app-login.module';
import { PaymentFlowModule } from './core-modules/payment-flow/payment-flow.module';
import { LoginModule } from './core-modules/login/login.module';
import { HomeModule } from './core-modules/home/home.module';
import { SharedModule } from './shared/shared.module';
import { PaperSetsModule } from './core-modules/paper-sets/paper-sets.module';
import { ReportModule } from './core-modules/report/report.module';
import { ActivityModule } from './core-modules/activity/activity.module';
import { LessonsModule } from './core-modules/lessons/lessons.module';
import { InstructionsModule } from './core-modules/instructions/instructions.module';
import { PaymentModule } from './core-modules/payment/payment.module';
import { TestModule } from './core-modules/test/test.module';
import { SettingModule } from './core-modules/setting/setting.module';
import { StaffModule } from './core-modules/staff/staff.module';
import { CheckoutModule } from './core-modules/checkout/checkout.module';
import { StatisticsModule } from './core-modules/statistics/statistics.module';
import { RegistrationModule } from './core-modules/registration/registration.module';

// import { TranslateModule } from './shared/modules/translate.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { OrderBy, CustomObserverService, QnavigatorService, ShoppingCartService, CurrencyPipe, RegistrationFeeService, RegistrationFeeTokenService } from './shared/';
import { LocalStorageModule } from 'angular-2-local-storage';
import { PendingChangesGuard } from './core-modules/login/services/route-deactivate';
import { CookieService } from 'ngx-cookie-service';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SubscriptionPackagesModule } from './core-modules/subscription-packages/subscription-packages.module';
import { LeaderboardComponent } from './core-modules/leaderboard/leaderboard.component';
import { WijayaNewsComponent } from './core-modules/wijaya-news/wijaya-news.component';
import { StripHtmlPipe } from './stripHtml';

/**
 * Importing sub moduls
 */

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,

    OrderBy,

    AppComponent,

    LeaderboardComponent,
    WijayaNewsComponent,
    TutorialsComponent

    //TranslatePipe

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BsModalModule,
    LoginModule,
    HomeModule,
    PaperSetsModule,
    ReportModule,
    ActivityModule,
    LessonsModule,
    InstructionsModule,
    PaymentModule,
    TestModule,
    SettingModule,
    StaffModule,
    CheckoutModule,
    RegistrationModule,
    // DynamicComponentModule,
    // NgComponentOutlet,
    ImageCropperModule,
    BrowserAnimationsModule,
    appRouting,
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LocalStorageModule.withConfig({
      prefix: 'grade5',
      storageType: 'localStorage'
    }),
    AppLoginModule,
    PaymentFlowModule,
    StatisticsModule,
    ChartsModule,
    SubscriptionPackagesModule,


  ],
  providers: [appRoutingProviders, CustomObserverService, PendingChangesGuard, ShoppingCartService, QnavigatorService, CookieService, RegistrationFeeService, RegistrationFeeTokenService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/app.module.ts